<template>
  <div class="time-edit">
    <div class="time-edit__label">{{ stringLabel }}:</div>
    <div class="time-edit__control">
      <div class="time-edit__control__input">
        <input :value="time" type="text" disabled />
      </div>
      <div class="time-edit__control__buttons">
        <div
          role="button"
          class="time-edit__control__buttons__button increase"
          @click="$emit('click-seconds', { stringType: type, numberSeconds: 1 })"
        >
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_up_todoelfut.png" alt="">
        </div>
        <div
          role="button"
          class="time-edit__control__buttons__button decrease"
          @click="$emit('click-seconds', { stringType: type, numberSeconds: -1 })"
        >
          <img src="https://golstatsimages.blob.core.windows.net/todoelfut/icn_arrow_down_todoelfut.png" alt="" >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaPlayerTimeEdit',
  props: {
    type: {
      type: String,
      default: 'start',
    },
    time: {
      type: String,
      default: '00:00',
    },
  },
  computed: {
    stringLabel() {
      return this.type === 'start' ? 'Inicio' : 'Final';
    },
  },
};
</script>

<style scoped lang="scss">
.time-edit {
  font-size: 1rem;
  padding: 6px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background-color: #f1f5f8;

  &__label {
    font-size: 0.9375em;
    font-family: Avenir-Demi, sans-serif;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.07;
    letter-spacing: normal;
    text-align: left;
    color: #132839;
    margin-right: 0.4em;
  }

  &__control {
    display: flex;
    align-items: center;

    &__input {
      & > input {
        width: 64px;
        text-align: center;
        height: 30px;
        font-family: Avenir-Bold, sans-serif;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.07;
        letter-spacing: normal;
        color: #132839;
      }
    }

    &__buttons {
      margin-left: 0.2em;
      &__button {
        width: 24px;
        height: 14px;
        background-color: #cfd7dd;
        margin: 1px 0;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;

        & > img {
          height: 7px;
          width: 10px;
        }

        &.increase {
          border-radius: 3px 3px 0 0;
        }

        &.decrease {
          border-radius: 0 0 3px 3px;
        }
      }
    }
  }

  @media screen and (max-width: 390px) {
    flex-direction: column;
    justify-content: flex-start;
  }
}
</style>
